import axios from 'axios'
// import getLocal from '@/common/cookie'
import store from '../store'
// import CONSTANT from '@/constant';
/**
 * Create Axios
 */

axios.defaults.withCredentials = true
export const http = axios.create({
  timeout: 60000,
  withCredentials: process.env.NODE_ENV !== 'development'
})
/**
 * Headers Config
 * 设置请求头信息
 */
http.defaults.headers.common = {
  // 'X-Session-Id': getGuid,
  // Authorization: `Bearer ${token}`
}

http.adornUrl = (actionName, url, type) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/api/]前缀做代理拦截!
  if (type) {
    return (process.env.NODE_ENV !== 'production' ? type : url) + actionName
  } else {
    return (process.env.NODE_ENV !== 'production' ? 'api' : url) + actionName
  }
}
/**
 * 处理请求时的姿势
 */
http.interceptors.request.use((config) => {
  // const token = getLocal.getCookie('token') || ''
  let tenantId = store.state.tenant ? store.state.tenant.id : null

  // var tenantId = localStorage.getItem('tenant-id')
  if (tenantId === null || tenantId === undefined || tenantId === 'null' || tenantId === '') {
    tenantId = localStorage.getItem('tenantId')
    if (tenantId === null || tenantId === undefined || tenantId === 'null' || tenantId === 'undefined' || tenantId === '') {
      tenantId = 1
    }
  }
  // config.headers.common['Authorization'] = `Bearer ${token}`
  config.headers.common['tenant-id'] = `${tenantId}`
  return config
}, () => {
  // 跳转到错误页面
  // Router.push({
  //   name: 'Error',
  // });
})

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    $http: {
      get () {
        return http
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/apis/index.js